<template>
  <tab-layout>
    <payment :cartMembers="cartMembers" :type="type" slot="tabContent" class="tab-pane col-12 col-xl-9 px-0 show active" id="payment" role="tabpanel" aria-label="Payment" />
  </tab-layout>
</template>

<script>
/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */

import tabLayout from '@/components/TabLayout'
import horseRegistrationPayment from '@/components/Payment'

export default {
  name: 'MyMembershipPayment',
  props: ['nominate'],
  components: {
    'tab-layout': tabLayout,
    payment: horseRegistrationPayment
  },
  data() {
    return {
      cartMembers: this.$store.state.cartMembers,
      type: 'registration'
    }
  },
  beforeMount() {
    if (this.nominate === 'rookie') {
      this.type = 'rookie-nomination'
    }
  },
  mounted() {
    if (this.cartMembers.hasOwnProperty('total') === false) {
      this.$router.push('/horses/register-horse/cart')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Horses/Cart/Payment.vue